// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_ads from '../../img/icons/24/ads.svg';
import Icon_data from '../../img/icons/24/data.svg';
import Icon_price from '../../img/icons/24/price.svg';
import Icon_social_media from '../../img/icons/24/social_media.svg';
import Icon_seo from '../../img/icons/24/seo.svg';
import Icon_arrow_right from '../../img/icons/24/arrow_right.svg';
import {Button} from '../../lib/button';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import styles from './use_cases.module.less';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';

interface i_use_case {
    title: string;
    text: string;
    icon?: JSX.Element;
}

const use_cases: i_use_case[] = [
    {
        title: 'Use cases',
      text: 'Our proxies are designed to meet your needs, ISP and '
        +'datacenter, providing reliable '
            +'solutions for clear access and optimal performance for '
            +'any use case.',
    },
    {
        icon: <Icon_ads />,
        title: 'Ad Verification',
        text: 'Optimize marketing campaigns for your target '
            +'audience. Simulating real visitors is an effective way to '
            +'prevent click frauds and other scams.',
    },
    {
        icon: <Icon_data />,
        title: 'Data Scraping',
        text: 'Get accurate and reliable data from anywhere. Ensure your '
            +'business stays anonymous while staying ahead of '
            +'the competition.',
    },
    {
        icon: <Icon_price />,
        title: 'Price Monitoring',
        text: 'Stay on top of your competition and economic trends. Develop '
            +'effective pricing strategies and expand your market with '
            +'valuable data.',
    },
    {
        icon: <Icon_social_media />,
        title: 'Social Media',
        text: 'Don\'t worry about bans on social media. No '
            +'geo-restrictions, easy to reach new markets. Manage one or '
            +'multiple social media accounts.',
    },
    {
        icon: <Icon_seo />,
        title: 'SEO & SERP',
        text: 'You can access high-quality proxies for SEO and SERP that '
            +'will prevent blocking and help you collect localized data '
            +'efficiently.',
    },
];

export const Use_cases = ()=>{
    const {theme} = useContext(Settings_context);
    const {show_free_zone_promo} = use_app_context();
    const {width} = use_screen();
    return <section className={styles.use_cases}>
      <div className={styles.cards_grid}>
        {use_cases.map((card, index)=>{
          return <div key={index} className={cn(styles.card,
            !card.icon && styles.head)}>
            {card.icon ? <>
              {card.icon}
              <p className={cn(theme.p20, theme.bold, styles.card_title)}>
                {card.title}</p>
              <p className={theme.p16}>{card.text}</p>
            </> : <>
              <p className={cn(theme.H2, styles.card_title)}>{card.title}</p>
              <p className={theme.p14}>{card.text}</p>
            </>}
          </div>;
        })}
      </div>
      <Button caption={<>{show_free_zone_promo ? 'Try now for free' : 'Try now' }<Icon_arrow_right/></>}
        size={width < 768 ? 'm' : 'l'} to={'/pricing'}/>
    </section>;
};
